import React from "react";

const PriscriptionHeader = ({ headerData }: { headerData: any }) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #c7c5c5",
    marginBottom: "4px",
  };

  const leftStyle = {
    fontSize: "18px",
    fontWeight: "bold",
  };

  const logoStyle = {
    maxHeight: "40px",
    width: "auto",
    objectFit: "contain",
  };

  const addressContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  };

  const branchStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "4px",
  };

  const isBranch = headerData?.locationTypeCode === "BRANCH";

  const showCareOf =
    !isBranch &&
    Boolean(headerData?.locationName) &&
    Boolean(headerData?.organazationName);

  return (
    <>
      {headerData?.locationTypeCode !== "BRANCH" && (
        <>
          <div style={branchStyle}>
            <div style={leftStyle} className="font-size-18">
              <div style={{ textAlign: "center" }}>
                {headerData?.locationName}
                <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                  {" "}
                  (
                  {headerData?.city === headerData?.locationCity
                    ? headerData?.city
                    : `${headerData?.city} ${headerData?.locationCity}`}
                  )
                </span>
              </div>
            </div>
          </div>
          <div style={{ borderBottom: "1px solid #c7c5c5", fontSize: "12px" }}>
            <div className="address-container" style={addressContainerStyle}>
              <div>
                {headerData?.locationAddress1} {headerData?.locationAddress2}
              </div>
            </div>
            <div
              className="address-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                marginBottom: "4px",
              }}
            >
              {headerData?.locationContactInformation}{" "}
              {headerData?.locationMobileNumber &&
                `, Mobile No.: ${headerData.locationMobileNumber}`}
              {headerData?.locationLandLineNumber &&
                `, LandLine No.: ${headerData.locationLandLineNumber}`}
            </div>
          </div>
        </>
      )}

      <div style={containerStyle}>
        <div style={leftStyle} className="font-size-18">
          <div>
            {showCareOf && <span style={{ marginRight: "4px", fontSize: "14px" }}>C/O</span>}
            <span
              style={{
                fontSize: showCareOf ? "14px" : "18px",
              }}
            >
              {headerData?.organazationName}
            </span>
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>
              {" "}
              ({headerData?.branchName})
            </span>
          </div>
        </div>
        {headerData?.logoServerImage && (
          <div
            style={{
              marginTop: "6px",
            }}
          >
            <img
              src={`data:image/png;base64,${headerData?.logoServerImage}`}
              alt="Logo"
              style={logoStyle}
            />
          </div>
        )}
      </div>
      <div style={{ borderBottom: "1px solid #c7c5c5", fontSize: "12px" }}>
        <div className="address-container" style={addressContainerStyle}>
          <div>
            {headerData?.address1} {headerData?.address2}
          </div>
        </div>
        <div
          className="address-container"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "4px",
          }}
        >
          {headerData?.branchContactInformation}{" "}
          {headerData?.mobileNumber &&
            `, Mobile No.: ${headerData.mobileNumber}`}
          {headerData?.landLineNumber &&
            `, LandLine No.: ${headerData.landLineNumber}`}
        </div>
      </div>
    </>
  );
};

export default PriscriptionHeader;
